module.exports = __webpack_public_path__ + "img/family-bio-characters.d07b9451.jpg";